import React, { useState } from 'react';
import './App.css';
import QuizPage from './components/QuizPage';
import ResultPage from './components/ResultPage';

function App() {
  const [quizCompleted, setQuizCompleted] = useState(false);
  const [quizResults, setQuizResults] = useState(null);

  const handleQuizComplete = (results) => {
    setQuizResults(results);
    setQuizCompleted(true);
  };

  const handleRestartQuiz = () => {
    setQuizCompleted(false);
    setQuizResults(null);
  };

  return (
    <div className="App">
      {/* <div className="top-logo">
        <img src="/images/om-logo.png" alt="Orange Money Logo" />
      </div> 
      <div className="bottom-logo">
        <img src="/images/bango.png" alt="Bango Logo" />
      </div>*/}
      {!quizCompleted ? (
        <QuizPage onQuizComplete={handleQuizComplete} />
      ) : (
        <ResultPage results={quizResults} onRestartQuiz={handleRestartQuiz} />
      )}
    </div>
  );
}

export default App;
